import { type CustomSeriesRenderItemAPI, type CustomSeriesRenderItemParams } from 'echarts';
import { util } from 'echarts/core';
import { type PathStyleProps } from 'zrender';
import { type DvMarkerOption } from '../../../../core/option';
import type { MarkerDataBuiltOption, markerRenderItemReturn } from '../type';

export interface PinStyleProps {
  // circleStyle: CustomCircleStyle;
  pinStyle: {
    style: PathStyleProps;
    shape: {
      width: number;
      height: number;
    };
  };
}

export function pin(
  data: MarkerDataBuiltOption<'pin'>,
  seriesOption: DvMarkerOption,
  api: CustomSeriesRenderItemAPI,
  params: CustomSeriesRenderItemParams
): markerRenderItemReturn {
  const { itemStyle, emphasis } = data;
  console.log('data', data);

  const point = api.coord([api.value(0), api.value(1)]);
  console.log('画图开始pin', point, itemStyle.pinStyle);

  const pinElement = {
    type: 'pin',
    x: point[0],
    y: point[1],
    shape: {
      x: 0,
      y: 0
    },
    emphasis: {
      scaleX: 1.2,
      scaleY: 1.2,
      style: {
        scaleX: 1.2,
        scaleY: 1.2,
        fill: '#fff',
        stroke: '#fff',
        lineWidth: 3
      }
    },
    blur: {
      fill: '#fff',
      lienWidth: 0
    },
    select: {
      style: {
        fill: 'green'
      }
    }
  };
  util.merge(pinElement, itemStyle.pinStyle);

  return {
    type: 'group',
    children: [pinElement]
  };
}
